import React from 'react';
import PropTypes from 'prop-types';

const Mortgage = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 114 114"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity=".2"
      d="M57 114c31.48 0 57-25.52 57-57S88.48 0 57 0 0 25.52 0 57s25.52 57 57 57z"
      fill="#B1E0E2"
    />
    <path
      d="M89.063 58.426L58.817 27.859a1.676 1.676 0 00-2.387 0L24.938 58.497"
      stroke="#2061AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M80.585 86.671H34.273a1.425 1.425 0 01-1.39-1.425V59.881a1.392 1.392 0 01.392-.997L56.039 36.12a1.745 1.745 0 012.423 0l23.263 22.764c.269.263.422.621.428.997v25.365a1.426 1.426 0 01-1.568 1.425v0z"
      stroke="#2061AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.907 69.757A4.631 4.631 0 0057 73.782a4.667 4.667 0 005.059-4.097A4.595 4.595 0 0057 65.695a4.702 4.702 0 01-5.13-4.025 4.667 4.667 0 015.13-4.097 4.631 4.631 0 015.095 4.026M56.857 54.545l.179 22.372M32.703 50.552V32.348c0-1.247.748-2.244 1.674-2.244h6.77c.925 0 1.638.997 1.638 2.244v3.277"
      stroke="#2061AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Mortgage.defaultProps = {
  className: '',
};

Mortgage.propTypes = {
  className: PropTypes.string,
};

export default Mortgage;
